/* eslint-disable indent,no-new,no-undef,valid-jsdoc */
import { SHOW_MODAL, SHOW_SLIDE_MENU, STORE_INVITE_STATS } from '@/store/action.types'
import { MAKE_MODAL_VISIBLE, MAKE_SLIDE_MENU_VISIBLE, SET_INVITE_STATS } from '@/store/mutation.types'

/**
 * Whether want to namespace it ot not
 * @type {boolean}
 */
export const namespaced = true

/**
 * State related to App
 * @type {Object}
 */
export const state = {
  modal: {
    show: false
  },
  menu: {
    slideMenu: {
      show: false
    }
  },
  statistics: {

  }
}

/**
 * Actions related to App
 * @type {Object}
 */
export const actions = {
  /**
   * Show/Hide modal globally
   * @param {object} context
   * @param {boolean} show
   */
  [SHOW_MODAL] (context, show = true) {
    context.commit(MAKE_MODAL_VISIBLE, show)
  },
  /**
   * Show/Hide Slide Side Menu
   * @param {object} context
   * @param {boolean} show
   */
  [SHOW_SLIDE_MENU] (context, show = true) {
    context.commit(MAKE_SLIDE_MENU_VISIBLE, show)
  },
  /**
   * Store Review Invite Data
   * @param {object} context
   * @param {boolean} inviteData
   */
  [STORE_INVITE_STATS] (context, inviteData) {
    context.commit(SET_INVITE_STATS, inviteData)
  }
}

/**
 * Mutations related to App
 * @type {Object}
 */
export const mutations = {
  /**
   * Make modal visible/hide globally
   * @param {object} state
   * @param {boolean} visibility
   */
  [MAKE_MODAL_VISIBLE] (state, visibility) {
    state.modal.show = visibility
  },
  /**
   * Make Slide Side Menu visible/hide globally
   * @param {object} state
   * @param {boolean} visibility
   */
  [MAKE_SLIDE_MENU_VISIBLE] (state, visibility) {
    state.menu.slideMenu.show = visibility
  },
  /**
   * Set Review Invite Data
   * @param {object} state
   * @param {boolean} inviteData
   */
   [SET_INVITE_STATS] (state, inviteData) {
    state.statistics = inviteData
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js